import { Fragment, ReactNode } from 'react';

type Props = {
  content: string;
};
export const LinkAvailableText = ({ content }: Props) => {
  const regexpUrl = /((h?)(ttps?:\/\/[a-zA-Z0-9.\-_@:/~?%&;=+#',()*!]+))/g;
  const matches = content.match(regexpUrl);

  if (matches) {
    const urls = matches.map((m) => m).join('|');
    const reg = new RegExp(`(${urls})`);
    const texts = content.toString().split(reg);

    return (
      <>
        {texts.map((t) => (
          <Fragment key={`${crypto.randomUUID()}`}>
            {urls.includes(t) ? (
              <a href={t} target="_blank" rel="noreferrer">
                {t}
              </a>
            ) : (
              <>{t}</>
            )}
          </Fragment>
        ))}
      </>
    );
  } else {
    return <>{content}</>;
  }
};
